import actionCreator from 'helpers/actionCreator'
import { UPDATE_PRESENTATION_VALUES } from 'actions/presentationActionTypes'

/** Called as an action when the presentation values need to be updated */
export const updatePresentationValuesAction = actionCreator(UPDATE_PRESENTATION_VALUES, 'key', 'value', 'fromMap', 'skipRoundFocal')



// WEBPACK FOOTER //
// ./src/actions/presentationActions.js